import { QueryFields } from "@directus/sdk";
import { fetchPartners } from "../api/partners";
import { GaripalliDirectusClient } from "../directus/client";
import { Partner } from "../directus/collections";
import { Schema } from "../directus/schema";

export async function getPartnersByIds(
  client: GaripalliDirectusClient,
  { partnerIds }: { partnerIds: string[] }
): Promise<Partner[]> {
  if (partnerIds?.length === 0) {
    return [];
  }

  const partners = await fetchPartners(client, {
    filter: {
      id: Array.isArray(partnerIds) ? { _in: partnerIds } : { _eq: partnerIds },
    },
    fields: ["*"] as QueryFields<Schema, Partner>,
  });
  return partners;
}
